<template>
    <div v-if="loading" class="loading-page">
        <p style="color: #333; font-size: 1rem">{{ text }}</p>
        <square-loader :loading="loading" :color="color" :height="height" :width="width"></square-loader>
    </div>
</template>

<script>
import SquareLoader from "vue-spinner/src/SquareLoader.vue";

export default {
  components: {
    SquareLoader
  },
  data() {
    return {
      color: "#3AB982",
      width: "100px",
      height: "100px"
    };
  },
  props: {
    loading: {
      type: Boolean
    },
    text: {
      type: String
    }
  }
};
</script>

<style scoped>
.loading-page {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  text-align: center;
  padding-top: 25%;
  font-size: 30px;
  font-family: sans-serif;
}
</style>
